import { FastField, Formik } from 'formik';
import KTFormGroup from 'general/components/OtherKeenComponents/Forms/KTFormGroup';
import KTFormInput, {
  KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import VIButton from 'general/components/VietInvoice/VIButton';
import OrganizationHelper from 'general/helpers/OrganizationHelper';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import * as Yup from 'yup';

ModalEditCompanyContent.propTypes = {
  onPressCancel: PropTypes.func,
  item: PropTypes.object,
};

ModalEditCompanyContent.defaultProps = {
  onPressCancel: null,
  item: null,
};

/**
 *
 * @param {{
 * onPressCancel: function,
 * item: object,
 * }} props
 * @returns
 */
function ModalEditCompanyContent(props) {
  // ---- params -----
  const { onPressCancel, item } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();

  // ---- methods -----
  function handlePressCancel() {
    if (onPressCancel) {
      onPressCancel();
    }
  }

  return (
    <div
      className=""
      style={{
        maxHeight: '70vh',
      }}
    >
      <Formik
        initialValues={{
          companyName: item?.organizationName ?? '',
        }}
        validationSchema={Yup.object({
          companyName: Yup.string().required(t('Required')),
        })}
        enableReinitialize
        onSubmit={(values) => {
          const params = {
            organizationName: values.companyName,
          };
          const res = OrganizationHelper.callApiUpdateOrganization(item?.organizationId, params);
          if (res) {
            handlePressCancel();
          }
        }}
      >
        {(formikProps) => (
          <div className="">
            <div className="row">
              {/* ten cong ty */}
              <div className="col-12">
                <KTFormGroup
                  label={
                    <>
                      {t('CompanyNameByBusinessLicense')} <span className="text-danger">(*)</span>
                    </>
                  }
                  inputName="companyName"
                  inputElement={
                    <FastField name="companyName">
                      {({ field, form, meta }) => (
                        <KTFormInput
                          name={field.name}
                          value={field.value}
                          onChange={(value) => {
                            form.setFieldValue(field.name, value);
                          }}
                          onBlur={() => {
                            form.setFieldTouched(field.name, true);
                          }}
                          enableCheckValid
                          isValid={_.isEmpty(meta.error)}
                          isTouched={meta.touched}
                          feedbackText={meta.error}
                          type={KTFormInputType.text}
                          placeholder={`${_.capitalize(t('CompanyName'))}`}
                        />
                      )}
                    </FastField>
                  }
                />
              </div>
            </div>

            {/* actions */}
            <div className="d-flex align-items-center justify-content-end gap-3">
              <VIButton
                text={t('Cancel')}
                className="btn-grey"
                style={{ padding: '8px' }}
                onClick={handlePressCancel}
              />
              <VIButton
                text={t('Save')}
                className=""
                style={{ padding: '8px' }}
                onClick={() => {
                  formikProps.handleSubmit();
                }}
              />
            </div>
          </div>
        )}
      </Formik>
    </div>
  );
}

export default ModalEditCompanyContent;
